import type { GenericServiceParameters } from "~/core/models/GenericServiceParameters.interface";
import LxcError from "~/core/models/LxcError.class";
import fleetService from "~/modules/fleet/services/fleet.service";

export function useDeleteFleets({
  organizationCode,
}: GenericServiceParameters<void>) {
  const result = ref<void>();
  const isLoading = ref(false);
  const error = ref<LxcError | null>(null);

  async function deleteFleets(fleetUIDs: string[]): Promise<void> {
    isLoading.value = true;

    const response = await fleetService.bulkDeleteOrganizationFleets({
      organizationCode,
      fleetUIDs,
    });

    if (LxcError.check(response)) {
      error.value = response;
      result.value = undefined;
    } else {
      error.value = null;
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    deleteFleets,
    result,
    error,
    isLoading,
  };
}
